import Base from './base'
import urls from 'config/urls'

class Role extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.role.find,
      data: opts
    })
  }

  get (opts) {
    return this.httpGet({
      url: urls.role.get,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.role.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.role.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.role.delete,
      data: opts
    })
  }

  getPermission (opts) {
    return this.httpGet({
      url: urls.role.getPermission,
      data: opts
    })
  }
}

export default new Role



// WEBPACK FOOTER //
// ./src/models/role.js